import { pxToRem } from '@withjoy/joykit/theme';

// Map Pin Image Styling Constants
// The large border width is specifically designed to create a prominent glass-like border effect
// for large map pin images, providing visual depth and ensuring proper contrast against map backgrounds
export const LARGE_IMAGE_BORDER_WIDTH_PX = 3.56;
export const LARGE_IMAGE_BORDER_WIDTH = pxToRem(LARGE_IMAGE_BORDER_WIDTH_PX);
export const STANDARD_IMAGE_BORDER_WIDTH = '1px';
export const GLASS_BORDER_COLOR = 'var(--Glass, rgba(255, 255, 255, 0.72))';
export const STANDARD_BORDER_COLOR = 'rgba(255, 255, 255, 0.72)';

// Map Animation Assets
export const MAP_ANIMATION_ICON_URL = 'https://withjoy.com/assets/public/apps/travel/lotties/map-animation.json';
